module.exports = __webpack_public_path__ + "img/what-flow-02.22ad45ce.svg";